import React, { useEffect, useState } from 'react';
import './LabPricingStyles.css';
import { MdOutlineArrowBackIos } from "react-icons/md";
import { useAlert } from 'react-alert';
import PanelShow from './PanelShow';
import TestShow from './TestShow';
import GroupShow from './GroupShow';
import { IoSearch } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import { FaPlus } from "react-icons/fa";
import Global from './Global';
import TestGroup from './TestGroup';
const LaboratoryTestPricing = () => {
  const [addGroup, setAddGroup] = useState(false);
  const [search, setSearch] = useState('');
  const [refresh, setRefresh] = useState(false)
  const navigate = useNavigate();
  const alert = useAlert();
  const [selectedOption, setSelectedOption] = useState('testgroup');

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleSuccess = () => {
    setAddGroup(false)
    setRefresh(!refresh)
  };

  return (
    <div className="lab-pricing-container">
      <div className="lab-pricing-header">
        <div style={{ display: "flex", alignItems: "baseline", flex: 2 }}>
          <button className="back-arrow" onClick={() => navigate('/data-management')}>
            <MdOutlineArrowBackIos />
          </button>
          <label className="lab-pricing-title">Laboratory tests</label>
        </div>
        <div style={{ display: "flex", justifyContent: 'space-between', flex: 5 }}>
          <div style={{ display: "flex", gap: "12px" }}>
            <label style={{ alignContent: "center", marginBottom: 0 }} >
              <input
                type="radio"
                value="testgroup"
                checked={selectedOption === 'testgroup'}
                onChange={handleOptionChange}
              />
              &nbsp;Test Group
            </label>
            <label style={{ alignContent: "center", marginBottom: 0 }}>
              <input
                type="radio"
                value="global"
                checked={selectedOption === 'global'}
                onChange={handleOptionChange}
              />
              &nbsp;Global
            </label>
          </div>
          {selectedOption === 'testgroup' && <button className='add-btn' style={{ height: '40px' }} onClick={() => { setAddGroup(!addGroup) }}><FaPlus />Group</button>}
        </div>
        <div style={{ display: "flex", flex: 2 }}>
          <div className='search-input' style={{ width: '130%', height: '40px' }}>
            <IoSearch />
            <input
              style={{ border: "none" }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search..."
            />
          </div>
        </div>
      </div>

      <div className="lab-pricing-content">
        {selectedOption === 'testgroup' ? <TestGroup search={search} refresh={refresh} /> : <Global search={search} refresh={refresh} />}
      </div>
      {addGroup && <GroupShow handleSuccess={handleSuccess} onClose={() => { setAddGroup(false) }} />}
    </div>
  );
};

export default LaboratoryTestPricing;